module.exports = __webpack_public_path__ + "img/Download.ac3a601b.png";